import { Routes } from '@angular/router';

import { AuthGuard } from './auth-guard.guard';
import { FallbackRedirectGuard } from './fallback-redirect.guard';
import { ModuleEnum } from './enum/module-enum';
import { AdminLayoutComponent } from './pages/layouts/admin/admin-layout.component';
import { LoginComponent } from './pages/login/login.component';

export const AppRoutes: Routes = [
    // {
    //     path: '',
    //     redirectTo: 'login',
    //     pathMatch: 'full',
    // },
    {
        path: 'login',
        component: LoginComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
                data: {
                    pageModule: ModuleEnum.DASHBOARD
                },
                canActivate: [AuthGuard]
            },
            {
                path: 'page-management',
                loadChildren: () => import('./pages/page-management/page-management.module').then(m => m.PageManagementModule),
                data: {
                    pageModule: ModuleEnum.NAV_PAGE
                },
                canActivate: [AuthGuard],
                runGuardsAndResolvers: 'always',  
            },
            {
                path: 'album-management',
                loadChildren: () => import('./pages/album-management/album-management.module').then(m => m.AlbumManagementModule),
                data: {
                    pageModule: ModuleEnum.NAV_ALBUM
                },
                canActivate: [AuthGuard],
                runGuardsAndResolvers: 'always',  

            },

            {
                path: 'banner-management',
                loadChildren: () => import('./pages/banner-management/banner-management.module').then(m => m.BannerManagementModule),
                data: {
                    pageModule: ModuleEnum.BANNER
                },
                canActivate: [AuthGuard]
            },
            {
                path: 'donation-management',
                loadChildren: () => import('./pages/donation-management/donation-management.module').then(m => m.DonationManagementModule),
                data: {
                    pageModule: ModuleEnum.DONATION
                },
                canActivate: [AuthGuard]

            },
            {
                path: 'activity-management',
                loadChildren: () => import('./pages/activity-management/activity-management.module').then(m => m.ActivityManagementModule),
                data: {
                    pageModule: ModuleEnum.ACTIVITY
                },
                canActivate: [AuthGuard]
            },
            {
                path: 'nav-layer-management',
                loadChildren: () => import('./pages/nav-layer-management/nav-layer-management.module').then(m => m.NavLayerManagementModule),
                data: {
                    pageModule: ModuleEnum.NAV_LAYER
                },
                canActivate: [AuthGuard]
            },
            {
                path: 'user-management',
                loadChildren: () => import('./pages/user-management/user-management.module').then(m => m.UserManagementModule),
                data: {
                    pageModule: ModuleEnum.USER_ACCOUNT
                },
                canActivate: [AuthGuard],
                runGuardsAndResolvers: 'always',  

            }, {
                path: 'venue-management',
                loadChildren: () => import('./pages/venue-management/venue-management.module').then(m => m.VenueManagementModule),
                data: {
                    pageModule: ModuleEnum.VENUE
                },
                canActivate: [AuthGuard],
                runGuardsAndResolvers: 'always',  

            },
            {
                path: 'shorten-url-management',
                loadChildren: () => import('./pages/shorten-url-management/shorten-url-management.module').then(m => m.ShortenUrlManagementModule),
                data: {
                    pageModule: ModuleEnum.SHORTEN_URL
                },
                canActivate: [AuthGuard]
            }, 
            {
                path: 'learning-management',
                loadChildren: () => import('./pages/learning-management/learning-management.module').then(m => m.LearningManagementModule),
                data: {
                    pageModule: ModuleEnum.LEARNING
                },
                canActivate: [AuthGuard]
            }, 
            {
                path: 'profile-setting',
                loadChildren: () => import('./pages/profile-setting/profile-setting.module').then(m => m.ProfileSettingModule),
                data: {
                    pageModule: ModuleEnum.PROFILE_SETTING
                },
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: '**',
        canActivate: [FallbackRedirectGuard],
        component: LoginComponent
    }
];
